import React, { useEffect } from 'react';


export default function App() {
  useEffect(() => {
    // Listen for messages from the iframe
    const handleMessage = (event) => {
      // Ensure the message is from a trusted origin (e.g., the child app)
      if (!event.origin) {
        return; // Skip if the origin is not available
      }
      // Handle the message
      if (event.data.type === 'REQUEST_PARENT_URL') {
        // Send the parent's URL back to the child
        event.source.postMessage(
          { type: 'PARENT_URL_RESPONSE', url: window.location.href },
          event.origin
        );
      }
    };
    window.addEventListener('message', handleMessage);
    // Clean up the event listener
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  
  return (
    <div>
      {/* <Navbar logo={logo}/> */}
      <div style={{ height: "100vh", width: "100vw", overflow: "hidden" }}>
        <iframe
          src="https://lynkit.in/warehouse-management"
          title="Lynkgrid WMS App"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allow="fullscreen"
        ></iframe>
      </div>
      {/* <Login /> */}
      {/* <Footer/> */}
    </div>

  )
}
